import { TableWrapper2 } from 'dsilo-ui-components';
import { TableWrapper3 } from 'dsilo-ui-components';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PUBLIC_PATH } from '../../constants';
import {
  getMembersList,
  clearReduxDataOfCurrentComponent,
  deleteOpportunity,
  deleteContractPDFAction,
  downloadSheet,
  downloadContractPDFAction,
  getContractDataById,
  getModelData,
  getDataModelById,
  getModelDataDropDown,
  hideSuccessMsg,
  changeAssigneeRequest,
  onUploadData,
  getCognitiveSearchData,
  getWorkflowById,
  downloadSheetBulkExcelOpportunity,
  getNextTasks,
  executeWorkFlow,
  getNextRespondent,
  getObligationTableData
} from '../../store/actions';
import { Loader } from '../loader';

const ListComponent = (props) => {
  return props?.isNewV1Theme ? (
    <TableWrapper3 {...props} PUBLIC_PATH={PUBLIC_PATH} loader={<Loader />} />
  ) : (
    <TableWrapper2 {...props} PUBLIC_PATH={PUBLIC_PATH} loader={<Loader />} />
  );
};


const mapDispatchToProps = {
  clearReduxDataOfCurrentComponent,
  getCognitiveSearchData,
  deleteOpportunity,
  deleteContractPDFAction,
  downloadSheet,
  downloadContractPDFAction,
  getContractDataById,
  getModelData,
  getDataModelById,
  getModelDataDropDown,
  hideSuccessMsg,
  getMembersList,
  changeAssigneeRequest,
  onUploadData,
  downloadSheetBulkExcelOpportunity,
  getNextTasks,
  getNextRespondent,
  executeWorkFlow,
  getObligationTableData
};

const mapStateToProps = state => {
  return {
    appConfig: state.appConfig.app,
    apps: state.app.app,
    login: state.login,
    user: state.user,
    formData: state.form,
    members: state.appConfig.members,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListComponent));
